
import { IFieldForm } from "pages/read-documents/model/IFieldForm";

export const fieldsFormUserTfe = (): IFieldForm[]  => {
    return [
        {
            id: 'itemFormUserName',
            name: 'name',
            type: 'text',
            label: 'Nombre de usuario',
            placeholder: 'Nombre de usuario',
            testId: 'itemFormUserName',
            isEnable: true
        },
        {
            id: 'itemformUserEmail',
            name: 'email',
            type: 'text',
            label: 'Email de usuario',
            placeholder: 'Ingrese email',
            testId: 'itemformUserEmail',
            isEnable: true
        },
    ]
}